import { render, staticRenderFns } from "./Physiotherapy.vue?vue&type=template&id=ed7bad28&"
import script from "./Physiotherapy.vue?vue&type=script&lang=js&"
export * from "./Physiotherapy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports